<template>
  <OmtLayoutContainer
    bg="#F6F6F9"
    :minHeight="['initial', 'calc(100vh - 80px)']"
  >
    <OmtRow v-if="insight">
      <CBox
        width="100%"
        mt="16px"
      >
        <OmtTypography
          as="h1-large"
          color="var(--colors-light-primary-dark-blue)"
          mb="8px"
          lineHeight="28px"
        >
          Resumo de {{ insight.DiaResumo }}
        </OmtTypography>
        <OmtTypography
          as="p2"
          color="var(--colors-light-primary-gray2)"
          mb="32px"
        >
          Baseado nos dados de saúde dos últimos 7 dias
        </OmtTypography>

        <WellnessReport :relatorio="insight.Relatorio" />
      </CBox>
    </OmtRow>

    <OmtRow v-else-if="error">
      <OmtTypography
        as="p1"
        color="var(--colors-light-primary-gray2)"
        mt="16px"
      >
        {{ error }}
      </OmtTypography>
    </OmtRow>
  </OmtLayoutContainer>
</template>

<script>
import { mapActions } from "vuex";
import { CBox } from "@chakra-ui/vue";
import WellnessReport from "@/components/Organisms/Wellness/WellnessReport.vue";

export default {
  name: "InsightsSaudeDetail",
  components: { CBox, WellnessReport },
  props: {
    // Id do resumo na Plataforma Wellness, como vem na listagem.
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      insight: null,
      error: null
    };
  },
  async mounted() {
    this.$root.$emit("show-loading");
    try {
      const insight = await this.fetchInsight({ id: this.id });
      if (insight?.Relatorio) {
        this.insight = insight;
      } else {
        this.error = "Resumo não encontrado";
      }
    } catch (error) {
      console.error(error);
      // A API responde "Resumo de saúde não encontrado." para resumo inexistente ou indisponível.
      this.error = error?.response?.data?.Error || error?.data?.Error || "Serviço temporariamente indisponível";
    } finally {
      this.$root.$emit("hide-loading");
    }
  },
  methods: {
    ...mapActions("insightsSaude", ["fetchInsight"])
  }
};
</script>
